
export default {
  name: 'BaseProfileProductDescription',
  props: {
    product: {
      type: Object,
      default: null,
    },
    author: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      maxCharactersToHidden: 1600,
      isShowContent: false,
    }
  },

  computed: {
    url() {
      switch (this.product?.type) {
        case 'GOODS':
          return `${this.author?.username}/goods/${this.product?._id}`
        case 'PRODUCT':
          return `offer/${this.product?._id}`
        case 'EVENT':
          return `${this.author?.username}/events/${this.product?._id}`
        case 'VACANCY':
          return `${this.author?.username}/vacancys/${this.product?._id}`
        default:
          return `offer/${this.product?._id}`
      }
    },
    serviceName() {
      switch (this.product?.type) {
        case 'GOODS':
          return 'продукта'
        case 'PRODUCT':
          return 'акции'
        case 'EVENT':
          return 'события'
        case 'VACANCY':
          return 'вакансии'
        case 'BROADCAST':
          return 'трансляции'
        default:
          return 'акции'
      }
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
    descriptions() {
      return this.product?.description
    },
    isAuthor() {
      if (this.$auth.loggedIn && this.author?._id) {
        return this.$auth?.user?._id === this.author?._id
      } else {
        return false
      }
    },
    isCompany() {
      return this.$auth.loggedIn && this.$auth.user?.type === 'COMPANY'
    },
    numberOfCharacters() {
      const paragraphs = this.descriptions?.blocks?.filter(
        (block) => block.type === 'paragraph'
      )
      const paragraphsTextLength =
        paragraphs && paragraphs.length
          ? paragraphs.reduce((acc, block) => {
              return acc + block.data.text.length
            }, 0)
          : 0
      const lists = this.descriptions?.blocks?.filter(
        (block) => block.type === 'list'
      )
      const listsTextLength = this.listTextLength(lists)

      const headers = this.descriptions?.blocks?.filter(
        (block) => block.type === 'header'
      )
      const headersTextLength =
        headers && headers.length
          ? headers.reduce((acc, block) => {
              return acc + block.data.text.length
            }, 0)
          : 0
      const quotes = this.descriptions?.blocks?.filter(
        (block) => block.type === 'quote'
      )
      const quotesTextLength =
        quotes && quotes.length
          ? quotes.reduce((acc, block) => {
              return acc + block.data.text.length + block.data.caption.length
            }, 0)
          : 0

      const tables = this.descriptions?.blocks?.filter(
        (block) => block.type === 'table'
      )
      const tablesTextLength =
        tables && tables.length
          ? tables.reduce((acc, block) => {
              return (
                acc +
                block.data.content.reduce((acc, el) => {
                  return (
                    acc +
                    el.reduce((acc, el) => {
                      return acc + el.length
                    }, 0)
                  )
                }, 0)
              )
            }, 0)
          : 0

      const countTextCharacters =
        paragraphsTextLength +
        listsTextLength +
        headersTextLength +
        quotesTextLength +
        tablesTextLength
      return countTextCharacters
    },
    isHidden() {
      return this.numberOfCharacters > this.maxCharactersToHidden
    },
    preText() {
      if (this.product?.shortDescription) {
        return this.product.shortDescription
      } else if (this.product?.description) {
        const text = this.product.description
        if (text?.blocks?.length) {
          const preText = text?.blocks?.find(
            (block) => block.type === 'paragraph'
          )
          return preText?.data?.text
        }
      }
      return null
    },
  },
  methods: {
    listTextLength(lists) {
      const listsTextLength =
        lists && lists.length
          ? lists.reduce((acc, block) => {
              return acc + this.countListItemsText(block.data.items)
            }, 0)
          : 0
      return listsTextLength
    },
    countListItemsText(items) {
      if (items && items.length) {
        return items.reduce((acc, item) => {
          let count = acc + item.content.length
          if (item.items && item.items.length) {
            count = count + this.countListItemsText(item.items)
          }
          return count
        }, 0)
      }
    },
  },
}
